// import login, {
//     SWITCH_LANGUAGE
// } from './login';
import languages from '../languages';
languages.init();

import { accountNameValidate, pwdValidate } from '../validator';
import {
  getJSON,
  post,
  getHrefParam,
  H5_HOST,
  // PASSPORT_HOST,
  HOME_HOST,
  isEmptyObj
} from '../ultile';
import { encryption } from '../../utiles';
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';

import globalConfig from '../../utiles/globalConfig';
import { ACCOUNT_TYPE } from '../../mixins/h5Sdk';
import { uploadEnterGame, uploadCreateRole } from '../../mixins/mobage';

export const PASSPORT_HOST = 'https://jppassport.37games.com/';
export const BASIC_HOST =
  window.pageInfo && window.pageInfo['host_name']
    ? `https://${window.pageInfo['host_name']}.37games.com/`
    : 'https://' + window.location.hostname + '/';
export const STORE_HOST = 'https://jpstore.37games.com/';
export const EVENTS_HOST = 'https://jpeventsapi.37games.com/';

export const TOURIST_AJAX = 'web_direct_login';
export const FB_AJAX = 'web_facebook';
export const TWITTER_AJAX = 'web_twitter';
const GET_USER_BIND_INFO = 'center/ajax/get_user_json';
const BIND_FB = 'web_facebook/bind';
const DE_BIND_FB = 'web_facebook/unbind';
const BIND_TWITTER = 'web_twitter/bind';
const DE_BIND_TWITTER = 'web_twitter/unbind';
const SWITCH_MC = 'web_migrate_code';
const GET_MC = 'center/ajax/get_migrate_code';
const CREATE_MC = 'center/ajax/generate_migrate_code';
const GET_USER_INFO = 'web_ad/login_status';
const GET_STORE_WAY = 'show_paytype';
const GET_PRODUCT_INFO_LINK = 'product_information';
const GET_DMM_PRODUCT_INFO_LINK = 'show_product';
const GET_REMAIN_POINT_LINK = 'dmm/point';
const GET_LAST_STORE_WAY = 'play_history/pay_history';
const GET_SERVER_LIST_LINK = 'ajax/server_list';
const GET_ROLE_LIST_LINK = 'ajax/get_user_role';
const EVENTS_BASIC_LINK = 'activity/execute';
const CLICK_DATAIN_LINK = '/static_activity/getClickInfo';
const VISIT_LOG_LINK = 'static_activity/visit_log';
const GET_UUID_LINK = 'static_activity/getUUID';
const GET_POINTS_INFO = 'points/getUserInfo';
const GET_COUPON_INFO = 'coupon/get_pay_coupon_list';
const SEND_VIP_COUPON = 'coupon/send_vip_coupon';
const CHECK_DMM_SIGN_LINK = 'dmm_login/checkSign';
const CHECK_DMM_LOGIN_LINK = 'dmm_login/checkDmmLogin';
const DMM_LOGOUT_LINK = 'dmm_login/dmmLogout';
const DMM_LOGIN_STATUS_LINK = 'dmm_login/login_status';
const GET_GMO_CHILD_LIST_LINK = 'gmo/child_list';
const GET_GMO_CHILD_FORM_LINK = 'gmo/form_data';
const DMM_LOGIN_HREF = '//jppassport.37games.com/dmm_login/login?game_id=2';
export const TRANSACTION_ID = globalConfig.getHrefParamUndecode(
  'transaction_id'
);
export const H = globalConfig.getHrefParamUndecode('h');
export const FROM_MOBAGE = !!globalConfig.getHrefParamUndecode('fromMobage');
export const MOBAGE_PC = !!globalConfig.getHrefParamUndecode('mobagePC');
export const HREF_IS_DMM = TRANSACTION_ID && H;
export const HREF_IS_MOBAGE = FROM_MOBAGE;
export const RESET_DATA = 'reset_data';
const IS_THIRD_PLATFORM = HREF_IS_MOBAGE || HREF_IS_DMM;

export const SAVE_USER_GAME_INFO = 'save_user_game_info';
export const GET_GAME_LINK = 'get_game_link';
export const GET_BASE_INFO = 'get_base_info';
export const RESET_GAME_LINK = 'reset_game_link';
export const ENTER_GAME = 'enter_game';
export const CREATE_ROLE = 'create_role';
const UPDATE_BASE_INFO = 'update_base_info';
const UPDATE_GAME_LINK = 'update_game_link';
export const UPDATE_USER_INFO = 'update_user_info';
const UPDATE_LOGIN_TAG = 'update_login_tag';
const UPDATE_STORE_WAY = 'update_store_way';
const UPDATE_PRODUCT_INFO = 'update_product_info';
const UPDATE_DMM_PRODUCT_INFO = 'update_dmm_product_info';
const UPDATE_REMAIN_POINT = 'update_remain_point';
const UPDATE_PRODUCT_ID = 'update_product_id';
const UPDATE_SERVER_LIST = 'update_server_list';
const UPDATE_ROLE_LIST = 'update_role_list';
const UPDATE_IS_EXT = 'update_is_exe';
const UPDATE_IS_AWARD = 'update_is_award';
const UPDATE_CHILD_LIST = 'update_child_list';
const UPDATE_CHILD_FORM = 'update_child_form';
const UPDATE_SHOW_PAY_WAT = 'update_show_pay_way';
export const UPDATE_BOOL_SEND_VIP_COUPON = 'update_bool_send_vip_coupon';

export const UPDATE_GAMEID = 'update_game_id';
export const SWITCH_LANGUAGE = 'switch_language';
export const DO_GET_USER_INFO = 'getUserInfo';
export const FETCH_PAY_WAY = 'fetch_pay_way';
export const FETCH_LAST_PAY_WAY = 'fetch_last_pay_way';
export const SUBMIT_PAY_TYPE = 'submit_pay_type';
export const GET_PRODUCT_INFO = 'get_product_info';
export const GET_DMM_PRODUCT_INFO = 'get_dmm_product_info';
export const GET_MOBAGE_PRODUCT_INFO = 'get_mobage_product_info';
export const GET_REMAIN_POINT = 'get_remain_point';
export const GET_SERVER_LIST = 'get_server_list';
export const GET_ROLE_LIST = 'get_role_list';
export const DATAIN_DATA = 'dotain_data';
export const CLICK_DATAIN = 'click_datain';
export const GET_REWARD_INFO = 'get_reward_info';
export const AWARD_GIFT = 'award_gift';
export const VISIT_LOG = 'visit_log';
export const GET_UUID = 'get_uuid';
export const CHECK_DMM_SIGN = 'checkSign';
export const CHECK_DMM_LOGIN = 'checkDmmLogin';
export const DMM_LOGOUT = 'dmmLogout';
export const DMM_LOGIN_STATUS = 'login_status';

export const RESET_CHILD_LIST = 'resetChildList';
export const RESET_CHILD_FORM = 'resetChildForm';
export const GET_CHILD_FORM = 'getChildForm';
export const GET_CHILD_LIST = 'getChildList';

export const GET_POINT_BALANCE = 'get_point_balance';
export const GET_PAY_COUPON_LIST = 'get_pay_coupon_list';
export const GET_SEND_VIP_COUPON = 'get_send_vip_coupon';

export const setLanguage = languages.setLanguage;

const ENTER_GAME_AJAX = HREF_IS_DMM ? 'dmm_add_server' : 'web_add_server';
const CREATE_ROLE_AJAX = HREF_IS_DMM ? 'dmm_add_role' : 'web_add_role';
const GET_GAME_LINK_AJAX = 'h5/play_games/enterGameUrl';
const GET_BASE_INFO_AJAX = 'h5/play_games/basic_page_info';
export const QR_CODE_AJAX = 'center/ajax/h5_qrcode';

export const HTTPS = 'https:';

export const forward = encodeURIComponent(window.location.href);
const thirdLoginParam = globalConfig.assignParamsObj(
  globalConfig.getHrefParamObj(),
  {
    forward: forward,
    language: ''
  }
);
const thirdLoginParamStr = globalConfig.objParamsToStrParams(thirdLoginParam);

export const FB_LOGIN_HREF = `${HTTPS}${PASSPORT_HOST}web_facebook/login?${thirdLoginParamStr}`;
export const TWI_LOGIN_HREF = `${HTTPS}${PASSPORT_HOST}web_twitter/login?${thirdLoginParamStr}`;
export const LINE_LOGIN_HREF = `${HTTPS}${PASSPORT_HOST}web_line/login?${thirdLoginParamStr}`;
let getUserInfoTimes = 1;

export default {
  state: {
    gameLink: '',

    floatIcon: '',
    bg: '',
    asideBtnList: [],
    shareList: [],
    isRegisterTerm: true,
    fbTitle: '',
    twitterTitle: '',
    tipsBg: '',

    serverId: '',
    serverName: '',
    roleId: '',
    roleName: '',
    gameId: '',

    accountName: '',
    accountId: '',
    isLogin: false,

    letter: languages.getAll(),
    lang: languages.language,

    totoalStoreWay: [],
    storeWay: [],
    productInfo: {},
    payChildList: [],
    childForm: {},
    dmmProductInfo: {},
    productId: '',
    serverList: [],
    roleList: [],
    isExe: false,
    isAward: false,

    commonTips: '',

    // 收藏獎勵是否已領
    favourHasGift: false,
    // 下載獎勵是否已領
    downloadHasGift: false,
    // 是否已请求发放VIP接口
    boolSendVipCoupon: false
  },
  getters: {
    letter: (state) => state.letter,
    isLogin: (state) => state.isLogin,
    gameId: (state) => state.gameId,
    lang: (state) => state.lang,
    serverId: (state) => state.serverId,
    roleId: (state) => state.roleId,
    roleName: (state) => state.roleName,
    accountName: (state) => state.accountName,
    accountId: (state) => state.accountId,
    storeWay: (state) => state.storeWay,
    productInfo: (state) => state.productInfo,
    payChildList: (state) => state.payChildList,
    childForm: (state) => state.childForm,
    serverList: (state) => state.serverList,
    roleList: (state) => state.roleList,
    isExe: (state) => state.isExe,
    isAward: (state) => state.isAward,
    productId: (state) => state.productId,
    dmmProductInfo: (state) => state.dmmProductInfo,
    commonTips: (state) => state.commonTips,
    favourHasGift: (state) => state.favourHasGift,
    downloadHasGift: (state) => state.downloadHasGift,
    boolSendVipCoupon: (state) => state.boolSendVipCoupon
  },
  mutations: {
    [UPDATE_BOOL_SEND_VIP_COUPON](state, bool) {
      state.boolSendVipCoupon = bool;
    },
    [UPDATE_BASE_INFO](state, data) {
      state.bg = data.bg;
      state.floatIcon = data.icon;
      state.shareList = data.share.shareList;
      state.asideBtnList = data.asideBtn;
      state.isRegisterTerm = data.isRegisterTerm;
      state.fbTitle = data.fb_title;
      state.twitterTitle = data.twitterText;
      state.tipsBg = data.tips;
    },
    [UPDATE_GAME_LINK](state, src) {
      state.gameLink = src;
    },
    [UPDATE_PRODUCT_ID](state, id) {
      state.productId = id;
    },
    [RESET_GAME_LINK](state) {
      state.gameLink = '';
    },
    [SAVE_USER_GAME_INFO](state, params) {
      state.serverId = params.serverId;
      state.serverName = params.serverName;
      state.roleId = params.roleId;
      state.roleName = params.roleName;
    },
    [RESET_DATA](state) {
      state.gameLink = '';
      state.serverId = '';
      state.serverName = '';
      state.roleId = '';
      state.roleName = '';
    },
    [UPDATE_GAMEID](state, params) {
      state.gameId = params;
    },
    [UPDATE_USER_INFO](state, params) {
      state.accountName = params.LOGIN_ACCOUNT;
      state.accountId = params.UID;
      state.isLogin = true;
    },
    [UPDATE_LOGIN_TAG](state, tag) {
      state.isLogin = tag;
    },
    // 切换语言
    [SWITCH_LANGUAGE](state) {
      state.letter = languages.getAll();
      state.lang = languages.language;
    },
    // 初始化渠道信息
    [UPDATE_STORE_WAY](state, payload) {
      let ways = isEmptyObj(payload.ways) ? state.totoalStoreWay : payload.ways;
      let lastPay = Array.isArray(payload.last) ? payload.last : [];
      // let res = [];
      // Vue.set(state, "storeWay", []);
      // state.storeWay.splice(state.storeWay.length);
      // 为了避免忽然数组忽然对象，还是用原始点的方法吧
      for (let key in ways) {
        let obj = {};
        if (!Array.isArray(ways[key])) {
          obj = Object.assign({}, ways[key], obj);
          if (ways[key].fType === lastPay[0] && ways[key].type === lastPay[1]) {
            obj.last = true;
          } else {
            obj.last = false;
          }
        } else {
          obj = {
            fType: ways[key][0],
            type: ways[key][1],
            currency: ways[key][2],
            name: ways[key][3],
            tips: ways[key][4],
            last: false,
            extraRadio: 0
          };
        }
        Vue.set(state.totoalStoreWay, parseInt(key, 10), obj);
      }
    },
    [UPDATE_SHOW_PAY_WAT](state) {
      let productInfo = state.productInfo;
      state.storeWay = state.totoalStoreWay.filter((item) => {
        let type = item.type;
        let typeIndex = productInfo.findIndex((item) => {
          return type === item.payType[1];
        });
        let hasThisType = typeIndex !== -1;
        // 2022/04/24 区天衡：日本平台礼包商品项第三方加码功能
        item.extraRatio = hasThisType ? productInfo[typeIndex].extraRatio : 0; // 添加加码比率
        return hasThisType;
      });
    },
    // 商品信息
    [UPDATE_PRODUCT_INFO](state, payload) {
      state.productInfo = payload.map((item) => {
        item.type = item.payType[1];
        item.extraRatio = item.commodity.EXTRA_RATIO;
        item.extraCoin = item.commodity.EXTRA_COIN;
        return item;
      });
    },
    // 商品信息-DMM
    [UPDATE_DMM_PRODUCT_INFO](state, payload) {
      state.dmmProductInfo = payload.find(
        (item) => item.PRODUCT_ID === state.productId
      );
    },
    // 余额-DMM
    [UPDATE_REMAIN_POINT](state, remainPoint) {
      state.dmmProductInfo['CAN_USE_POINT'] = remainPoint;
    },
    // 服务器列表
    [UPDATE_SERVER_LIST](state, payload) {
      state.serverList = payload;
    },
    // 角色列表
    [UPDATE_ROLE_LIST](state, payload) {
      state.roleList = payload;
    },
    // 是否为微端进入
    [UPDATE_IS_EXT](state, payload) {
      state.isExe = payload;
    },
    // 是否已领奖
    [UPDATE_IS_AWARD](state, payload) {
      state.isAward = payload;
    },
    [RESET_CHILD_LIST](state) {
      state.payChildList = [];
    },
    [RESET_CHILD_FORM](state) {
      state.childForm = {};
    },
    [UPDATE_CHILD_LIST](state, payload) {
      if (payload && payload.map) {
        payload.map((item) => {
          state.payChildList.push({
            type: item.id,
            name: item.name,
            last: false
          });
        });
        // for (let key in payload) {
        //   state.payChildList.push({
        //     type: key,
        //     name: payload[key],
        //     last: false
        //   });
        // }
      }
    },
    [UPDATE_CHILD_FORM](state, payload) {
      state.childForm = payload;
    },
    updateCommonTips(state, text) {
      console.log('commit');
      state.commonTips = text;
    },
    getAwardState(state, data) {
      state.favourHasGift = data.likeAward;
      state.downloadHasGift = data.downloadAward;
    }
  },
  actions: {
    // 打点数据上报
    [DATAIN_DATA]({ commit, state }, payload) {
      // function serializeData(data) {
      //   let dataStr = "";
      //   for (let fieldName in data) {
      //     dataStr += "&" + fieldName + "=" + data[fieldName];
      //   }
      //   return dataStr;
      // }
      // const dataCountId = HREF_IS_DMM ? 9 : 7;
      // const baseUrl = `https://datain.octlib.com/api/v1/hw/common/event/collect?apikey=72e0e1c0-51e3-45ab-9b36-bf3b82143d9d&id=${dataCountId}&gameID=${state.gameId}`;
      // const dataStr = serializeData(payload);
      // const img = document.createElement("img");
      // img.src = baseUrl + dataStr;
      // document.body.appendChild(img);
      // document.body.removeChild(img);
    },
    // 获取游戏服务器列表
    [GET_SERVER_LIST]({ commit, state }) {
      return new Promise((resolve) => {
        getJSON(STORE_HOST + GET_SERVER_LIST_LINK, {
          game_id: state.gameId
        }).then((res) => {
          commit(UPDATE_SERVER_LIST, res.data);
          resolve();
        });
      });
    },
    // 获取服务器角色列表
    [GET_ROLE_LIST]({ commit, state }, payload) {
      return new Promise((resolve) => {
        getJSON(STORE_HOST + GET_ROLE_LIST_LINK, {
          game_id: state.gameId,
          server_id: payload
        }).then((res) => {
          let data = res.data;
          if (res.errmsg === 'キャラクターが存在しない') {
            data = [
              {
                roleID: '-1',
                roleName: 'キャラクターが存在しない',
                roleLevel: '1'
              }
            ];
          }
          commit(UPDATE_ROLE_LIST, data);
          resolve();
        });
      });
    },
    // 发奖接口
    [AWARD_GIFT]({ commit }, payload) {
      return new Promise((resolve) => {
        getJSON(EVENTS_HOST + EVENTS_BASIC_LINK, {
          name: 'beautyreward',
          action: 'award',
          params: payload
        }).then((res) => {
          resolve(res);
        });
      });
    },
    // 获取微端基础信息
    [GET_REWARD_INFO]({ commit }, payload) {
      return new Promise((resolve) => {
        getJSON(EVENTS_HOST + EVENTS_BASIC_LINK, {
          name: 'beautyreward',
          action: 'basic',
          params: payload
        }).then((res) => {
          commit(UPDATE_IS_EXT, res.data.is_exe);
          commit(UPDATE_IS_AWARD, res.data.is_award);
          resolve();
        });
      });
    },
    // 点击统计
    [CLICK_DATAIN]({ commit }, payload) {
      return new Promise((resolve) => {
        getJSON(EVENTS_HOST + CLICK_DATAIN_LINK, {
          activityId: 'beautyreward',
          buttonName: payload
        }).then((res) => {
          resolve();
        });
      });
    },
    // 获取uuid
    [GET_UUID]({ commit }, payload) {
      return new Promise((resolve) => {
        getJSON(EVENTS_HOST + GET_UUID_LINK, {
          language: '',
          appLanguage: ''
        }).then((res) => {
          let uuid = res.data.uuid || '';
          resolve(uuid);
        });
      });
    },
    [CHECK_DMM_SIGN]({ commit, dispatch, state }, param) {
      return new Promise((resolve, reject) => {
        commit(UPDATE_LOGIN_TAG, false);
        sessionStorage.setItem('hasCheckDmmSign', '1');
        const params = {
          dmm_h: param.h,
          transaction_id: param.transaction_id,
          game_id: 2
        };
        // 新增-如果dmm_login/login_status成功，则不请求checkSign
        dispatch(DMM_LOGIN_STATUS).then((res) => {
          const data = res.res.data;
          localStorage.setItem('currLoginAccount', data.LOGIN_ACCOUNT);
          if (!(data.IS_BIND_DMM && data.DMM_USER_ID)) {
            getJSON(PASSPORT_HOST + CHECK_DMM_SIGN_LINK, params).then((res) => {
              if (res.res.result === '1') {
                localStorage.setItem(
                  'currLoginAccount',
                  res.data.LOGIN_ACCOUNT
                );
                dispatch(CHECK_DMM_LOGIN);
              } else {
                sessionStorage.setItem('isDMM', 0);
                alert(res.res.msg || '失敗しました');
              }
            });
          } else {
            sessionStorage.setItem('usedDmmlogin', '1');
            sessionStorage.setItem('isDMM', 1);
            dispatch(DO_GET_USER_INFO).then(() => {
              dispatch(UPDATE_GAMEID, 2).then(() => {
                dispatch(GET_GAME_LINK);
              });
            });
          }
        });
      });
    },
    [CHECK_DMM_LOGIN]({ commit, dispatch, state }, isFromStore) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + CHECK_DMM_LOGIN_LINK, {
          game_id: 2
        }).then((res) => {
          if (res.res.result === '1') {
            if (isFromStore) {
              resolve();
            } else {
              sessionStorage.setItem('usedDmmlogin', '1');
              sessionStorage.setItem('isDMM', 1);
              dispatch(DO_GET_USER_INFO).then(() => {
                dispatch(UPDATE_GAMEID, 2).then(() => {
                  dispatch(GET_GAME_LINK);
                });
              });
            }
          } else {
            sessionStorage.setItem('isDMM', 0);
            window.location.href = DMM_LOGIN_HREF;
          }
        });
      });
    },
    [DMM_LOGOUT]({ commit, dispatch, state }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + DMM_LOGOUT_LINK, {
          game_id: 2
        }).then((res) => {
          resolve();
        });
      });
    },
    [DMM_LOGIN_STATUS]({ commit, dispatch, state }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + DMM_LOGIN_STATUS_LINK, {
          game_id: 2
        }).then((res) => {
          resolve(res);
        });
      });
    },
    // 页面pv，uv统计
    [VISIT_LOG]({ commit }, payload) {
      return new Promise((resolve) => {
        getJSON(EVENTS_HOST + VISIT_LOG_LINK, {
          name: 'beautyreward',
          source_url: encodeURIComponent(window.location.href),
          referer_url: encodeURIComponent(document.referrer),
          uuid: payload,
          ...window.globalGetLinkParams()
        }).then((res) => {
          resolve();
        });
      });
    },
    [GET_CHILD_LIST]({ commit }, payload) {
      return new Promise((resolve) => {
        getJSON(STORE_HOST + payload.fType + '/child_list', {
          pay_type: payload.pay_type
        }).then((res) => {
          if (res.res.result === '1') {
            commit(UPDATE_CHILD_LIST, res.data);
          }
          resolve(res.data);
        });
      });
    },
    [RESET_CHILD_LIST]({ commit }) {
      commit(RESET_CHILD_LIST);
    },
    [RESET_CHILD_FORM]({ commit }) {
      commit(RESET_CHILD_FORM);
    },
    [GET_CHILD_FORM]({ commit }, payload) {
      return new Promise((resolve) => {
        getJSON(STORE_HOST + payload.fType + '/form_data', {
          pay_type: payload.pay_type,
          child_id: payload.child_id
        }).then((res) => {
          let data = {};
          if (res.res.result === '1') {
            data = res.data;
          }
          commit(UPDATE_CHILD_FORM, data);
          resolve(true);
        });
      });
    },
    // 获取代币余额
    [GET_POINT_BALANCE]() {
      return getJSON(STORE_HOST + GET_POINTS_INFO, {});
    },
    // vip系统：发放优惠券
    [GET_SEND_VIP_COUPON]({ commit }, params) {
      return getJSON(STORE_HOST + SEND_VIP_COUPON, params);
    },
    // 获取用户可用优惠卷列表
    [GET_PAY_COUPON_LIST]({ commit }, params) {
      return getJSON(STORE_HOST + GET_COUPON_INFO, params);
    },
    // 获取商品信息
    [GET_PRODUCT_INFO]({ commit, state }, payload) {
      return new Promise((resolve) => {
        getJSON(STORE_HOST + GET_PRODUCT_INFO_LINK, {
          game_id: state.gameId,
          location: 'JP',
          product_id: payload.productId
        }).then((res) => {
          commit(UPDATE_PRODUCT_INFO, res.data);
          commit(UPDATE_SHOW_PAY_WAT);
          resolve();
        });
      });
    },
    // 获取商品信息-Mobage
    [GET_MOBAGE_PRODUCT_INFO]({ commit, state }, payload) {
      return new Promise((resolve) => {
        commit(UPDATE_PRODUCT_ID, payload.productId);
        getJSON(STORE_HOST + GET_DMM_PRODUCT_INFO_LINK, {
          game_id: state.gameId || 2,
          server_sid: payload.serverId,
          role_id: payload.roleId,
          fpaytype: 'mobage_nbpf',
          paytype: 'mobage_nbpf',
          currency: 'MOBA',
          product_id: payload.productId
        }).then((res) => {
          resolve(res.data[0].list);
        });
      });
    },
    // 获取商品信息-DMM
    [GET_DMM_PRODUCT_INFO]({ commit, dispatch, state }, payload) {
      return new Promise((resolve) => {
        commit(UPDATE_PRODUCT_ID, payload.productId);
        getJSON(STORE_HOST + GET_DMM_PRODUCT_INFO_LINK, {
          game_id: state.gameId || 2,
          server_sid: payload.serverId,
          role_id: payload.roleId,
          fpaytype: 'dmm',
          paytype: 'dmm',
          currency: 'JPY',
          product_id: payload.productId
        }).then((res) => {
          commit(UPDATE_DMM_PRODUCT_INFO, res.data[0].list);
          dispatch(GET_REMAIN_POINT).then(() => {
            resolve();
          });
        });
      });
    },
    // 获取余额-DMM
    [GET_REMAIN_POINT]({ commit, state }, payload) {
      return new Promise((resolve) => {
        getJSON(STORE_HOST + GET_REMAIN_POINT_LINK, {}).then((res) => {
          commit(UPDATE_REMAIN_POINT, res.data.can_use_point);
          resolve();
        });
      });
    },
    // 确认储值
    [SUBMIT_PAY_TYPE]({ commit, state }, payload) {
      const data = !payload.notStringify
        ? qs.stringify(payload.params)
        : payload.params;
      return axios.post(payload.url, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    },
    // 获取储值渠道
    [FETCH_PAY_WAY]({ commit, state }) {
      return new Promise((resolve) => {
        getJSON(STORE_HOST + GET_STORE_WAY, {
          game_id: state.gameId,
          location: 'JP',
          language: 'jp',
          plat: globalConfig.getHrefParamUndecode('app_id') ? 'fb' : 'web'
        }).then((res) => {
          commit(UPDATE_STORE_WAY, {
            ways: res.data,
            last: {}
          });
          resolve(res.data);
        });
      });
    },
    // 获取上次储值渠道
    [FETCH_LAST_PAY_WAY]({ commit, state }, data) {
      return new Promise((resolve) => {
        getJSON(STORE_HOST + GET_LAST_STORE_WAY, {
          game_id: state.gameId,
          platform: 'jp'
        }).then((res) => {
          commit(UPDATE_STORE_WAY, {
            ways: data || {},
            last: res.data.history ? res.data.history : ''
          });
          resolve();
        });
      });
    },
    // 获取游戏链接
    [GET_GAME_LINK]({ commit, state }) {
      return new Promise((resolve) => {
        let params = {
          game_id: state.gameId,
          language: state.lang,
          appLanguage: state.lang,
          isFbCanvas: globalConfig.getHrefParamUndecode('fbcanvas') || ''
        };
        if (IS_THIRD_PLATFORM) {
          const channel = HREF_IS_DMM ? 'dmm' : HREF_IS_MOBAGE ? 'mobage' : '';
          params = {
            game_id: state.gameId,
            channel
          };
          if (HREF_IS_MOBAGE && MOBAGE_PC) {
            params = Object.assign({}, params, {
              mobagePC: MOBAGE_PC ? 1 : 0,
              uid: globalConfig.getHrefParamUndecode('uid'),
              loginAccount: globalConfig.getHrefParamUndecode('loginAccount'),
              accessToken: globalConfig.getHrefParamUndecode('accessToken'),
              timeStamp: globalConfig.getHrefParamUndecode('timeStamp')
            });
          }
        }
        getJSON(
          '//' +
            window.pageInfo.host_name +
            '.37games.com/' +
            GET_GAME_LINK_AJAX,
          params
        ).then((res) => {
          // 分享活动透传参数，以后就用这两个吧，c确定活动，deep-link-value的深度链接带的参数
          let realEnterUrl =
            res.data.enterUrl +
            '&deep_link_value=' +
            globalConfig.getHrefParamUndecode('deep_link_value') +
            '&c=' +
            globalConfig.getHrefParamUndecode('c');
          sessionStorage.setItem('gameLink1', realEnterUrl);
          commit(UPDATE_GAME_LINK, realEnterUrl);
          resolve();
        });
      });
    },
    // 获取基础信息
    [GET_BASE_INFO]({ commit, dispatch, state }) {
      return new Promise((resolve) => {
        getJSON(BASIC_HOST + GET_BASE_INFO_AJAX, {
          game_id: state.gameId
        }).then((res) => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_BASE_INFO, res.res.data);
            dispatch(SWITCH_LANGUAGE, res.res.data.lang);
          }
          resolve();
        });
      });
    },
    // 进入游戏回调
    [ENTER_GAME]({ commit, state }, param) {
      return new Promise((resolve) => {
        let params = {
          game_server_sid: param.serverId,
          language: state.lang,
          appLanguage: state.lang,
          game_id: state.gameId,
          loginName: state.accountName,
          uid: state.accountId,
          ...param.otherParam
        };
        getJSON(PASSPORT_HOST + ENTER_GAME_AJAX, params).then((res) => {
          resolve();
        });
      });
    },
    [CREATE_ROLE]({ commit, state }, param) {
      return new Promise((resolve) => {
        let params = {
          game_server_sid: param.serverId,
          language: state.lang,
          appLanguage: state.lang,
          game_id: state.gameId,
          loginName: state.accountName,
          uid: state.accountId,
          ...param.otherParam
        };
        getJSON(PASSPORT_HOST + CREATE_ROLE_AJAX, params).then((res) => {
          resolve();
        });
      });
    },
    // 重置数据
    [RESET_DATA]({ commit }) {
      commit(RESET_DATA);
    },
    // 保存用户角色信息
    [SAVE_USER_GAME_INFO]({ commit }, params) {
      commit(SAVE_USER_GAME_INFO, params);
    },
    [UPDATE_GAMEID]({ commit }, params) {
      commit(UPDATE_GAMEID, params);
    },
    // 切换语言
    [SWITCH_LANGUAGE]({ commit, dispatch }, param) {
      languages.setLanguage(param);
      commit(SWITCH_LANGUAGE);
      // commit(UPDATE_TIPS);
    },
    touristLogin({ commit, dispatch, state }, params) {
      return new Promise((resolve) => {
        const TRANSACTION_ID = globalConfig.getHrefParamUndecode(
          'transaction_id'
        );
        const H = globalConfig.getHrefParamUndecode('h');
        if (TRANSACTION_ID && H) {
          const param = {
            transaction_id: TRANSACTION_ID,
            h: H
          };
          if (sessionStorage.getItem('hasCheckDmmSign') !== '1') {
            dispatch(CHECK_DMM_SIGN, param);
          }
        } else {
          getJSON(PASSPORT_HOST + TOURIST_AJAX + window.location.search, {
            loginId: params,
            game_id: state.gameId,
            language: state.lang,
            appLanguage: state.lang,
            packageName: globalConfig.packageName
          }).then((res) => {
            if (parseInt(res.res.result, 10) === 1) {
              commit(UPDATE_USER_INFO, res.data);
              localStorage.setItem('currLoginAccount', res.data.LOGIN_ACCOUNT);
            }
            resolve(res.res);
          });
        }
      });
    },
    fbLogin({ commit, state }, { accessToken, appId }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + FB_AJAX + window.location.search, {
          accessToken: accessToken,
          appId: appId,
          game_id: state.gameId,
          language: state.lang,
          appLanguage: state.lang,
          packageName: globalConfig.packageName
        }).then((res) => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_USER_INFO, res.data);
          } else {
            try {
              globalConfig.statistics('login_fail', {
                login_type: ACCOUNT_TYPE.fb,
                msg: res.res.msg
              });
            } catch (e) {}
          }
          resolve(res.res);
        });
      });
    },
    twitterLogin({ commit, state }, { authToken, authSecret }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + TWITTER_AJAX + window.location.search, {
          authToken: authToken,
          authSecret: authSecret,
          game_id: state.gameId,
          language: state.lang,
          appLanguage: state.lang,
          packageName: globalConfig.packageName
        }).then((res) => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_USER_INFO, res.data);
          } else {
            try {
              globalConfig.statistics('login_fail', {
                login_type: ACCOUNT_TYPE.tw,
                msg: res.res.msg
              });
            } catch (e) {}
          }
          resolve(res.res);
        });
      });
    },
    getUserBindInfo({ commit, state }, params) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + GET_USER_BIND_INFO + window.location.search, {
          gameId: state.gameId,
          isStore: 0,
          language: state.lang,
          appLanguage: state.lang
        }).then((res) => {
          resolve(res);
        });
      });
    },
    bindFbAccount({ commit, state }, { accessToken, appId }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + BIND_FB + window.location.search, {
          accessToken: accessToken,
          appId: appId,
          game_id: state.gameId,
          language: state.lang,
          appLanguage: state.lang
        }).then((res) => {
          resolve(res);
        });
      });
    },
    bindTwitterAccount({ commit, state }, { authToken, authSecret }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + BIND_TWITTER + window.location.search, {
          authToken: authToken,
          authSecret: authSecret,
          game_id: state.gameId,
          language: state.lang,
          appLanguage: state.lang
        }).then((res) => {
          resolve(res);
        });
      });
    },
    debindFbAccount({ commit, state }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + DE_BIND_FB + window.location.search, {
          game_id: state.gameId,
          language: state.lang,
          appLanguage: state.lang
        }).then((res) => {
          resolve(res.res);
        });
      });
    },
    debindTwitterAccount({ commit, state }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + DE_BIND_TWITTER + window.location.search, {
          game_id: state.gameId,
          language: state.lang,
          appLanguage: state.lang
        }).then((res) => {
          resolve(res.res);
        });
      });
    },
    switchMigrateCode({ commit, state }, { code, pw, uuid }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + SWITCH_MC + window.location.search, {
          game_id: state.gameId,
          code: code,
          pw: pw,
          loginId: uuid,
          packageName: globalConfig.packageName
        }).then((res) => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_USER_INFO, res.data);
          } else {
            try {
              globalConfig.statistics('login_fail', {
                login_type: ACCOUNT_TYPE.mg,
                msg: res.res.msg
              });
            } catch (e) {}
          }
          resolve(res.res);
        });
      });
    },
    getMigrateCode({ commit, state }) {
      return new Promise((resolve) => {
        getJSON(PASSPORT_HOST + GET_MC + window.location.search, {
          gameId: parseInt(state.gameId, 10)
        }).then((res) => {
          resolve(res);
        });
      });
    },
    createMigrateCode({ commit, state }, { pw, repw, gpid }) {
      {
        return new Promise((resolve) => {
          post(PASSPORT_HOST + CREATE_MC + window.location.search, {
            gameId: parseInt(state.gameId, 10),
            pw: pw,
            repw: repw,
            gpid: gpid
          }).then((res) => {
            resolve(res);
          });
        });
      }
    },
    [DO_GET_USER_INFO]({ commit, state }) {
      return new Promise((resolve) => {
        if (HREF_IS_DMM) {
          commit(UPDATE_USER_INFO, {});
          resolve();
        } else if (HREF_IS_MOBAGE) {
          resolve();
        } else {
          getJSON(PASSPORT_HOST + GET_USER_INFO + window.location.search, {
            gameId: state.gameId,
            isStore: 0,
            language: state.lang,
            appLanguage: state.lang
          }).then((res) => {
            if (parseInt(res.res.result, 10) === 1) {
              localStorage.setItem('currLoginAccount', res.data.LOGIN_ACCOUNT);
              commit(UPDATE_USER_INFO, res.data);
              if (getUserInfoTimes === 1) {
                let type = localStorage.getItem('jp_h5_login_account') || 'to';
                try {
                  globalConfig.statistics('login_success', {
                    login_type: `自动登录-${type}`
                  });
                } catch (e) {}
                getUserInfoTimes++;
              }
            }
            resolve(res.res);
          });
        }
      });
    },
    fbUpdateUserInfo({ commit }, params) {
      commit(UPDATE_USER_INFO, params);
    },
    pcCodeLogin({ commit }, params) {
      return new Promise((resolve) => {
        getJSON(
          PASSPORT_HOST + 'web_login_code/login',
          Object.assign({}, params, { packageName: globalConfig.packageName })
        ).then((res) => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_USER_INFO, res.data);
          }
          resolve(res);
        });
      });
    },
    get_award({ state }, params) {
      return new Promise((resolve) => {
        getJSON(BASIC_HOST + 'index/sendGift', {
          sid: state.serverId,
          serverID: state.serverId,
          roleId: state.roleId,
          params: {
            sid: state.serverId,
            roleId: state.roleId
          },
          language: state.lang,
          appLanguage: state.lang,
          ...params
        }).then((res) => {
          resolve(res.res);
        });
      });
    },
    get_award_state({ commit, state }) {
      return new Promise((resolve) => {
        getJSON(BASIC_HOST + 'index/awardState', {
          language: state.lang,
          appLanguage: state.lang
        }).then((res) => {
          if (res.res.result == '1') {
            commit('getAwardState', res.data);
          }
          resolve();
        });
      });
    }
  }
};
